import {
  MdOutlineVpnLock,
  MdManageSearch,
  MdSystemSecurityUpdateGood,
} from "@onemind-services-llc/react-icons-ng/md";
import { GiFirewall } from "@onemind-services-llc/react-icons-ng/gi";

export const HEADING_CONSTANTS = {
  title: "Our Achievements",
  description:
    "CloudMyLab has been recognized with a prestigious international industry Cloud Award (The Security Awards 2025) for our security solutions. A reflection of our relentless dedication, quiet excellence, and unwavering belief in what we’re building together. In a world where security is mission-critical, CloudMyLab has not only stood out — it’s been celebrated. We set out to solve real problems, protect our clients, and build trust through innovation.",
};

export const ACHIEVEMENTS_LIST = [
  {
    icon: MdOutlineVpnLock,
    title: "Best VPN Security Solution",
    pdfSrc: "/achievements/VPNsec.pdf",
    desc: "Recognized for delivering enterprise-grade VPN protection with seamless user experience.",
  },
  {
    icon: GiFirewall,
    title: "Best Firewall Security Solution",
    pdfSrc: "/achievements/FirewallSecSoln.pdf",
    desc: "Awarded for our next-gen firewall that redefines network perimeter security and threat prevention.",
  },
  {
    icon: MdSystemSecurityUpdateGood,
    title: "Best Security Solution for Virtual Applications / Virtual Desktops",
    pdfSrc: "/achievements/SecSolution.pdf",
    desc: "Honored for securing virtualized environments with advanced threat detection and zero-trust access.",
  },
  {
    icon: MdManageSearch,
    title: "Best Incident Management Solution",
    pdfSrc: "/achievements/IncidentMangement.pdf",
    desc: "Celebrated for our proactive incident response platform ensuring swift containment and recovery.",
  },
];
